import React, { Component } from "react";
import clientX from "../../../utils/clientX";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { showToastMessage } from "../../../utils/helper";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import voucherClientX from "../../../utils/api/voucherClientX";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import classNames from "classnames";
import icRow from "../../../assets/orders/ic_arrow.png"
import Lottie from "lottie-react";
import EarnReward from "../../../assets/orders/ic_trophy.json";
import EarnedReward from "../../../assets/orders/ic_won_cash.json";
export default class OrderDetail extends Component {
  _isMounted = false;

  constructor(props) {
    super(props);

    this.state = {
      order: null,
      vouchers: [],
      voucherStatus: null,
      isFetchingVoucherCodes: false,
      canDownloadReceipt: false,
    };
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  downloadReceipt = () => {
    voucherClientX
      .get(`/v1/order/${this.state.order.id}/receipt`)
      .then((response) => {
        window.open(response.data.data.receipt);
      });
  };

  componentDidMount() {
    this._isMounted = true;
    const {
      match: { params },
    } = this.props;

    clientX.get(`v1/vouchers/orders/${params.id}`).then((response) => {
      let data = response.data.data;
      if (this._isMounted) {
        this.setState({
          order: data,
        });

        if (3 === parseInt(data.status)) {
          this.setState({
            canDownloadReceipt: true,
          });
        }

        if (data.fulfilled && !data.voucher_code_generated) {
          this.setState({ voucherStatus: "pending" });
          return;
        }

        if (data.voucher_code_generated) {
          this.process(params.id);
        }
      }
    });
  }

  process = (paramsId) => {
    this.setState({ isFetchingVoucherCodes: true }, () => {
      clientX
        .get(`v1/vouchers/orders/${paramsId}/codes`)
        .then((response) => {
          let data = response.data.data;
          this.setState({
            vouchers: data,
            isFetchingVoucherCodes: false,
            voucherStatus: "success",
          });
        })
        .catch((error) => {
          this.setState({
            isFetchingVoucherCodes: false,
          });
          toast.error(
            "Voucher Code Not Generated Yet.",
            {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            }
          );
        });
    });
  };

  viewVoucher = () => {
    const {
      match: { params },
    } = this.props;

    this.process(params.id);
  };

  viewInvoice = (url) => {
    window.open(url);
  };

  Shimmer = (props) => {
    return (
      <div className="container-fluid py-3 py-md-5">
        <div className="row">
          <div className="col-12 col-md-6 offset-md-3">
            <div className="box shine box-voucher-detail-logo"></div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const {
      order,
      vouchers,
      voucherStatus,
      isFetchingVoucherCodes,
      canDownloadReceipt,
    } = this.state;
    return (
      order === null ?
        <this.Shimmer />
        :
        null !== order && (
          <React.Fragment>
            <div className="container-fluid">
              <div className="row mt-3 mb-3 mt-md-4 mb-md-4 align-items-center">
                <div className="col-12 text-md-center">
                  <small>
                    <Link to="/">
                      <FormattedMessage
                        id="breadcrumbs.home"
                        defaultMessage="Home"
                      />
                    </Link>
                  </small>{" "}
                  /{" "}
                  <small>
                    <Link to="/orders">
                      <FormattedMessage id="navbar.orders" />
                    </Link>
                  </small>{" "}
                  /{" "}
                  <small>
                    <strong>
                      <FormattedMessage id="orders.order" />
                    </strong>
                  </small>
                </div>
              </div>
              <div className="row mb-3 mb-md-4">
                <div className="col-md-6 offset-md-3">
                  <div className="list-group">
                    <div className="list-group-item list-group-item-action">
                      <img
                        className="mt-2 mt-md-0"
                        src={order.web_image_url}
                        style={{
                          background: "#fff",
                          height: "30px",
                          border: "1px solid rgba(0, 0, 0, 0.125)",
                          display: "inline",
                          boxSizing: "content-box",
                          padding: "15px 0",
                          borderRadius: "0.25rem",
                          marginRight: "15px",
                        }}
                        alt={order.voucher_name}
                      />
                      <p className="d-block d-md-inline mt-1 mt-md-0 mb-0">
                        <FormattedMessage id="orders.purchase-of-voucher" />{" "}
                        <strong>{order.voucher_name}</strong>
                      </p>
                    </div>
                    <div className="list-group-item list-group-item-action">
                      <div className="row align-items-center">
                        <div className="col-md-6">
                          <OrderStatusLabel order={order} />
                        </div>
                        <div className="col-md-6 text-md-right">
                          <p className="mb-0">
                            <FormattedMessage id="orders.your-order-number-is" />{" "}
                            <strong>{order.order_number}</strong>
                          </p>

                          <p className="mb-0">{order.created_at}</p>
                        </div>
                      </div>
                    </div>
                    <div className="list-group-item list-group-item-action">
                      <p className="mb-0">
                        <>
                          <PaymentStatusLabel order={order} />
                        </>
                      </p>
                    </div>
                    <div className="list-group-item list-group-item-action">
                      <p className="mb-0">
                        <strong>{order.wrp}</strong> WRP{" "}
                        {order.wrp_credited ? "credited" : "are pending"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mb-3 mb-md-4">
                <div className="col-md-6 offset-md-3">
                  {isFetchingVoucherCodes ? (
                    <div className="box shine"></div>
                  ) : "pending" === voucherStatus ? (
                    <div className="alert alert-primary" role="alert">
                      <p className="mb-0">
                        <FormattedMessage
                          id="order.voucher-processing"
                          defaultMessage="Voucher Code is being processed. Please"
                        />{" "}
                        <button
                          className="btn btn-outline view-voucher-btn"
                          onClick={this.viewVoucher}
                          style={{ color: "#087CD8" }}
                        >
                          <FormattedMessage
                            id="order.voucher-click-here"
                            defaultMessage="click here"
                          />
                        </button>{" "}
                        <FormattedMessage
                          id="order.voucher-to-view"
                          defaultMessage="
                        to view voucher code"
                        />
                      </p>
                    </div>
                  ) : (
                    vouchers.map((item, index) => {
                      return (
                        <React.Fragment key={index}>
                          <h6 className="font-weight-bold mt-3">{`Voucher ${index +
                            1}`}</h6>
                          <Voucher item={item} />
                        </React.Fragment>
                      );
                    })
                  )}
                  <div className="display-btns-wrapper">
                    {/* add enlarge-btn to increase width */}
                    <div
                      className={classNames("btn-wrapper", {
                        "enlarge-btn": !order.invoice_url,
                        "disable-btn": !canDownloadReceipt,
                      })}
                    >
                      {canDownloadReceipt && (
                        <button
                          className="btn btn-outline-primary home-btn mt-3"
                          onClick={this.downloadReceipt}
                        >
                          <FormattedMessage
                            id="general.download-receipt"
                            defaultMessage="Download Receipt"
                          />
                        </button>
                      )}
                    </div>
                    <div
                      className={classNames("btn-wrapper", {
                        "enlarge-btn": !canDownloadReceipt,
                        "disable-btn": !order.invoice_url,
                      })}
                    >
                      {order.invoice_url && (
                        <button
                          className="btn btn-outline-primary home-btn mt-3"
                          onClick={() => this.viewInvoice(order.invoice_url)}
                        >
                          <FormattedMessage
                            id="order.view-invoice"
                            defaultMessage="View Invoice"
                          />
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {order.won_reward === false ?
                null :
                order.rewards_cliamed === false ?
                  claimNow(order) : claimed(order)
              }
            </div>
          </React.Fragment>
        )
    );
  }
}


const claimNow = (order) => {
  return (
    <div className="row mb-3 mb-md-4 ">
      <div className="col-md-6 offset-md-3">
        <Link to="/rewards">
          <div className="row mb-4 order-reward-earned">
            <div className="col-9 centered">
              <h3>You have earned the reward on this transaction!</h3>
              <span className="flex-icon">CLAIM NOW
                <img style={{ marginLeft: "5px" }} src={icRow} alt="arrow" width="30px" />
              </span>
            </div>
            <div className="col-3">
              <Lottie animationData={EarnReward} loop={true} width="50" />
            </div>
          </div>
        </Link>
      </div>
    </div>
  )
}

const claimed = (order) => {
  return (
    <div className="row mb-3 mb-md-4 ">
      <div className="col-md-6 offset-md-3">
        <Link to="/rewards">
          <div className="row mb-4 order-reward-earned">
            <div className="col-9 centered">
              <h3>You have won {order.reward_label} as Rewards for this transaction!</h3>
            </div>
            <div className="col-3">
              <Lottie animationData={EarnedReward} loop={true} width="50" />
            </div>
          </div>
        </Link>
      </div>
    </div>
  )
}

// const winCash = (order) => {
//   return (
//     <div className="row mb-3 mb-md-4 ">
//       <div className="col-md-6 offset-md-3">
//         <Link to="/rewards">
//         <div className="row mb-4 order-reward-cash">
//             <div className="col-9 centered">
//              <h3>Spend Rs. 100 or more on WINDS and win cash & WRP as Rewards</h3>
//             </div>
//             <div className="col-3">
//             </div>
//         </div>
//         </Link>
//       </div>
//     </div>
//   )
// }

const Voucher = (props) => {
  function renderTooltip(properties) {
    return (
      <Tooltip {...properties} show="true">
        Click to Copy
      </Tooltip>
    );
  }
  const { voucher_number, voucher_pin, expiry_date } = props.item;
  return (
    <React.Fragment>
      <div className="list-group">
        <div className="list-group-item list-group-item-action">
          <p className="mb-0">
            <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip}
            >
              <span
                style={{
                  cursor: "pointer",
                  color: "rgb(8, 124, 216)",
                }}
                onClick={() => {
                  navigator.clipboard.writeText(voucher_number);
                  showToastMessage(
                    "success",
                    "Voucher Code copied to the clipboard"
                  );
                }}
              >
                {voucher_number}
              </span>
            </OverlayTrigger>
          </p>
          <p className="mb-0 text-muted">
            <small>VOUCHER CODE</small>
          </p>
        </div>
        <div className="list-group-item list-group-item-action">
          <p className="mb-0">
            {voucher_pin ? (
              <OverlayTrigger
                placement="right"
                delay={{ show: 250, hide: 400 }}
                overlay={renderTooltip}
              >
                <span
                  style={{
                    cursor: "pointer",
                    color: "rgb(8, 124, 216)",
                  }}
                  onClick={() => {
                    navigator.clipboard.writeText(voucher_pin);
                    showToastMessage(
                      "success",
                      "Voucher PIN copied to the clipboard"
                    );
                  }}
                >
                  {voucher_pin}
                </span>
              </OverlayTrigger>
            ) : (
              <span>NA</span>
            )}
          </p>
          <p className="mb-0 text-muted">
            <small>VOUCHER PIN</small>
          </p>
        </div>
        <div className="list-group-item list-group-item-action">
          <p className="mb-0">{expiry_date}</p>
          <p className="mb-0 text-muted">
            <small>EXPIRY DATE</small>
          </p>
        </div>
      </div>
    </React.Fragment>
  );
};

function PaymentStatusLabel(props) {
  const status = props.order.status;
  switch (status) {
    case 0:
      return (
        <React.Fragment>
          <FormattedMessage
            id="order.payment-of-rs"
            defaultMessage="Payment of Rs."
          />{" "}
          <strong>{props.order.amount}</strong>{" "}
          <FormattedMessage
            id="order.payment-pending"
            defaultMessage="is Pending"
          />
        </React.Fragment>
      );
    case 1:
    case 8:
      return (
        <React.Fragment>
          <FormattedMessage
            id="order.payment-of-rs"
            defaultMessage="Payment of Rs."
          />{" "}
          <strong>{props.order.amount}</strong>{" "}
          <FormattedMessage
            id="order.payment-failed"
            defaultMessage="is Failed"
          />
        </React.Fragment>
      );
    default:
      return (
        <React.Fragment>
          <FormattedMessage
            id="order.payment-of-rs"
            defaultMessage="Payment of Rs."
          />{" "}
          <strong>{props.order.amount}</strong>{" "}
          <FormattedMessage
            id="order.payment-success"
            defaultMessage="is Successful"
          />
        </React.Fragment>
      );
  }
}

function OrderStatusLabel(props) {
  switch (props.order.status) {
    case 3:
      return (
        <p className="badge badge-success text-white mb-0">
          {props.order.status_text_translated}
        </p>
      );
    case 4:
      return (
        <p className="badge badge-danger text-white mb-0">
          {props.order.status_text_translated}
        </p>
      );
    default:
      return (
        <p className="badge badge-warning text-white mb-0">
          {props.order.status_text_translated}
        </p>
      );
  }
}
